import React, { useState, useEffect, useCallback } from 'react';
import { Link, useLocation } from 'react-router-dom';
import recentSearchesManager from '../utils/recentSearches';
import './RecentSearchesSidebar.css';

function RecentSearchesSidebar({ database }) {
  const [recentSearches, setRecentSearches] = useState([]);
  const [isCollapsed, setIsCollapsed] = useState(false);
  const location = useLocation();

  const loadRecentSearches = useCallback(() => {
    const searches = database
      ? recentSearchesManager.getSearchesByDatabase(database)
      : recentSearchesManager.getRecentSearches();
    setRecentSearches(searches.slice(0, 5)); // Show only 5 most recent
  }, [database]);

  useEffect(() => {
    loadRecentSearches();
  }, [loadRecentSearches]);

  const handleSearchClick = (search) => {
    // Navigate with query parameter
    const searchUrl = `${location.pathname}?q=${encodeURIComponent(search.query)}`;
    window.location.href = searchUrl;
  };

  const handleRemoveSearch = (e, searchId) => {
    e.stopPropagation();
    recentSearchesManager.removeSearch(searchId);
    loadRecentSearches();
  };

  if (recentSearches.length === 0) {
    return null;
  }

  return (
    <div className={`recent-searches-sidebar ${isCollapsed ? 'collapsed' : ''}`}>
      <div className="sidebar-header">
        <h3>🔍 Recent Searches</h3>
        <button
          onClick={() => setIsCollapsed(!isCollapsed)}
          className="collapse-btn"
          title={isCollapsed ? 'Expand' : 'Collapse'}
        >
          {isCollapsed ? '▶' : '◀'}
        </button>
      </div>

      {!isCollapsed && (
        <div className="sidebar-content">
          {recentSearches.map((search) => (
            <div
              key={search.id}
              className="recent-search-item"
              onClick={() => handleSearchClick(search)}
            >
              <div className="search-info">
                <div className="search-query">{search.query}</div>
                <div className="search-meta">
                  <span className="search-time">
                    {recentSearchesManager.formatTimestamp(search.timestamp)}
                  </span>
                  {search.resultsCount > 0 && (
                    <span className="search-count">
                      {search.resultsCount} results
                    </span>
                  )}
                </div>
              </div>
              <button
                onClick={(e) => handleRemoveSearch(e, search.id)}
                className="remove-search-btn"
                title="Remove from recent searches"
              >
                ✕
              </button>
            </div>
          ))}

          <div className="sidebar-footer">
            <Link to="/saved-searches" className="view-all-link">
              View All Saved Searches →
            </Link>
          </div>
        </div>
      )}
    </div>
  );
}

export default RecentSearchesSidebar;